// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__uyfi8","header":"MessagesList_header__2-Wjd","chat":"MessagesList_chat__2jGWw"};